'use client'
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import 'swiper/css';
import 'swiper/css/pagination';
import MainMenu from '@/components/MainMenu';
import Image from 'next/image'
import Link from 'next/link'
import { useCallback, useEffect, useState } from 'react';
import { sendRequestNoToken } from '@/utils/apiService';
import { SpinningSkeletonLoader } from '@/components/skeleton/SpinningSkeleton';
import { formatDateTime, Video } from '@/utils/types';
import Pagination from '@/components/Pagination';

export default function Page() {
  const { phoneNumber, isCookieLoading } = usePhoneNumber();
  const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState(true);
    const [result, setResult] = useState<Video[]>([]);

    const handlePageChange = (page: number) => {
        fetchData(page)
    };


    const fetchData = useCallback((currentPage: number) => {
        setCurrentPage(currentPage);
        setIsLoading(true);
        const params = new URLSearchParams({
            page: currentPage.toString(),
        });
        sendRequestNoToken("GET", `/api/mycast/list/`, null)
            .then((data) => {
                setResult(data.results);
                setTotalPages(data.total_pages);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);


    useEffect(() => {
       fetchData(1)
    }, [fetchData]);


  return (
	<main className="flex flex-col items-center justify-between overflow-hidden">
	  <MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} />
            <section className="text-start pt-10 pb-0 md:pt-24 w-screen justify-start bg-gradient-to-b from-gradient-start to-white dark:from-purple-700 dark:to-dark-800">
				<div className='container mt-20 mb-10 md:mb-20 text-center'>
					<div>
						<div className='text-4xl md:text-6xl font-semibold'>
							my<span className='text-purple-500'>Cast</span>
						</div>
						<div className='text-lg mt-10 max-w-[600px] mx-auto'>
                        Өөр өөр салбарын төлөөллүүдтэй ажил мэргэжил, ажлын арга барилынх нь талаар өрнүүлсэн яриаг сонсоорой. 
						</div>
					</div>
				</div>
			</section>


            <section className='min-h-[50vh] w-full bg-white pb-10 dark:bg-dark-800'>
                <div className='container flex flex-col space-y-8 md:space-y-4'>
                    <div className='hidden md:flex'>
                    {isLoading ? (
                        <div className='w-full flex justify-center my-8'><SpinningSkeletonLoader /></div>
                        
                    ) : (<div className="md:grid grid-cols-4 pb-10 gap-4">
                            {result.map((item, index) => (
                            <div key={index} className='rounded-lg relative group overflow-hidden'>
                                <Image
                                    src={item.headshot_url}
                                    width={0}
                                    height={0}
                                    alt={''}
                                    sizes="100vw"
                                    className="h-auto w-full mx-auto rounded-xl"
                                />
                                <div className="absolute bottom-0 w-full flex flex-col justify-center items-center mb-4">
                                    <Image
                                        src={item.title_text_image_url}
                                        width={0}
                                        height={0}
                                        alt={''}
                                        sizes="100vw"
                                        className="h-auto w-[60%] mx-auto rounded-xl transition-all duration-500 ease-in-out transform translate-y-0 group-hover:-translate-y-16"
                                    />
                                    <div className='mx-auto w-[20px] bg-white h-[3px] duration-500 ease-in-out transform translate-y-0 group-hover:-translate-y-16'></div>
                                    <div className="mx-6 mt-2 text-center text-white transition-all font-semibold duration-500 ease-in-out transform translate-y-0 group-hover:-translate-y-16">{item.subtitle}</div>
                                </div>
                                <div className="flex absolute bottom-0 w-full transform translate-y-16 group-hover:translate-y-0 transition-all duration-500 ease-in-out justify-center pb-4">
                                    <Link className='w-full mx-6' href={`/mycast/${item.url}`}><button className="bg-white text-career-dark-500 px-4 py-2 rounded w-full text-sm font-semibold">Дэлгэрэнгүй</button></Link>
                                </div>
                            </div>
                            ))}
                        </div>
                    )}
                    </div>

                    <div className='md:hidden'>
                    {isLoading ? (
                        <div className='w-full flex justify-center my-8'><SpinningSkeletonLoader /></div>
                    ) : (<div className="grid grid-cols-1 pb-10 gap-4">
                            {result.map((item, index) => (
                            <Link key={index} href={`/mycast/${item.url}`} className='rounded-lg relative group overflow-hidden'>
                                <Image
                                    src={item.mobile_headshot_url}
                                    width={0}
                                    height={0}
                                    alt={''}
                                    sizes="100vw"
                                    className="h-full w-full mx-auto rounded-xl transform scale-150 translate-x-[50px]" 
                                />
                                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 w-[150px] flex flex-col justify-center items-center mb-4">
                                    <Image
                                        src={item.title_text_image_url}
                                        width={0}
                                        height={0}
                                        alt={''}
                                        sizes="100vw"
                                        className="w-full mx-auto rounded-xl"
                                    />
                                    <div className='mx-auto w-[20px] bg-white h-[3px] my-2'></div>
                                    <div className="text-center text-white font-semibold text-sm">{item.subtitle}</div>
                                </div>
                            </Link>
                            ))}
                        </div>
                    )}
                    </div>

                    <div className="mt-8 flex justify-center">
                        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} onPageChange={handlePageChange} isLoading={isLoading} />
                    </div>
                </div>
            </section>
	  <Footer />
	</main>
  )
}
